export enum PathUnit {
  Login = "login",
  NotificationsMgmt = 'notifications-mgmt',
  ComingSoon = 'comingsoon',
  Forbidden = 'forbidden',
  Unauthorized = 'unauthorized',

  // TVMS
  Dashboard = 'dashboard',
  FleetManagement = 'fleet-management',
  VehicleCheckIns = 'vehicle-check-ins',
  FleetManagementDetail = 'fleet-management-detail',
  FleetManagementCreate = 'fleet-management-create',
  FleetManagementEdit = 'fleet-management-edit',
  FleetManagementView = 'fleet-management-view',
  ReportsManage = 'reports-manage',
  InspectionReport = 'inspection-report',
  InspectionReportCreate = 'inspection-report-create',
  // InspectionReportsByFleet = 'inspection-reports-by-fleet',
  DeviationReport = 'deviation-report',
  DeviationReportCreate = 'deviation-report-create',
  DeviationReportDetail = 'deviation-report-detail',
  DeviationReportEdit = 'deviation-report-edit',
  DeviationVoiceReport = 'deviation-voice-report',
  DeviationVoiceReportDetail = 'deviation-voice-report-detail',
  DeviationReportStudio = 'deviation-report-studio',
  EventObservations = 'event-observations',
  EventObservationMobile = 'event-observations-mobile',
  InspectionReportDetail = 'inspection-report-detail',
  InspectionReportEdit = 'inspection-report-edit',
  ImageUploadTest = 'image-upload-test',
  UXDemo = 'ux-demo',
  
  HistorySoftwareVersions = 'history-software-versions',
}

export const PagePath = {
  // [PathUnit.LandingPage]: `${PathUnit.LandingPage}`,
  [PathUnit.NotificationsMgmt]: `${PathUnit.NotificationsMgmt}`,
  [PathUnit.ComingSoon]: `${PathUnit.ComingSoon}`,
  [PathUnit.Forbidden]: `${PathUnit.Forbidden}`,
  [PathUnit.Unauthorized]: `${PathUnit.Unauthorized}`,

  // TVMS
  [PathUnit.Login]: `${PathUnit.Login}`,
  [PathUnit.Dashboard]: `${PathUnit.Dashboard}`,
  [PathUnit.FleetManagement]: `${PathUnit.FleetManagement}`,
  [PathUnit.VehicleCheckIns]: `${PathUnit.VehicleCheckIns}`,
  [PathUnit.FleetManagementDetail]: `${PathUnit.FleetManagement}/:id`,
  [PathUnit.FleetManagementCreate]: `${PathUnit.FleetManagement}/create`,
  [PathUnit.FleetManagementEdit]: `${PathUnit.FleetManagement}/edit/:id`,
  [PathUnit.FleetManagementView]: `${PathUnit.FleetManagement}/view/:id`,
  [PathUnit.ReportsManage]: `${PathUnit.ReportsManage}`,
  [PathUnit.InspectionReport]: `${PathUnit.InspectionReport}`,
  [PathUnit.InspectionReportCreate]: `${PathUnit.InspectionReport}/create`,
  // [PathUnit.InspectionReportsByFleet]: `${PathUnit.InspectionReport}/:id`,
  [PathUnit.DeviationReport]: `${PathUnit.DeviationReport}`,
  [PathUnit.DeviationReportCreate]: `${PathUnit.DeviationReport}/create`,
  [PathUnit.DeviationReportDetail]: `${PathUnit.DeviationReport}/:id/:reportId`,
  [PathUnit.DeviationReportEdit]: `${PathUnit.DeviationReport}/:id/:reportId/edit`,
  [PathUnit.DeviationVoiceReport]: `${PathUnit.DeviationVoiceReport}`,
  [PathUnit.DeviationVoiceReportDetail]: `${PathUnit.DeviationVoiceReport}/:id`,
  [PathUnit.DeviationReportStudio]: `${PathUnit.DeviationReportStudio}`,
  [PathUnit.EventObservations]: `${PathUnit.EventObservations}`,
  [PathUnit.EventObservationMobile]: `${PathUnit.EventObservationMobile}`,
  [PathUnit.InspectionReportDetail]: `${PathUnit.InspectionReport}/:id/:reportId`,
  [PathUnit.InspectionReportEdit]: `${PathUnit.InspectionReport}/:id/:reportId/edit`,
  [PathUnit.ImageUploadTest]: `${PathUnit.ImageUploadTest}`,
  [PathUnit.UXDemo]: `${PathUnit.UXDemo}`,
  [PathUnit.HistorySoftwareVersions]: `${PathUnit.UXDemo}/${PathUnit.HistorySoftwareVersions}`,
}

export function getPath(pageName: PathUnit): string {
  return PagePath[pageName];
}